import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import OrgTreeButton from "../buttons/OrgTreeButton";
import { fetchCustomerFilters } from "@actions";
import ExpandButton from "@buttons/ExpandButton";
import useCustomerView from "@hooks/useCustomerView";
import StatusLabels from "@common/components/shared/StatusLabels";
import SimpleInputComponent from "@common/components/shared/forms/SimpleInputComponent";
import DatePeriodFilters from "@common/components/shared/DatePeriodFilters";
import useCustomerFilters from "@hooks/useCustomerFilters";
import SimpleSelectComponent from "@forms/SimpleSelectComponent";
import { handleError } from "@common/components/helpers/error";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";
import fetchIdentityOptions from "@common/components/helpers/Customer/fetchIdentityOptions";
import { appendPlaceholders } from "@common/components/helpers/identity";
import LoadingAction from "@common/redux/actions/LoadingAction";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import CustomerClient from "@common/api/CustomerClient";
import LoginAction from "@common/redux/actions/LoginAction";


const CustomerFilters = (props) => {
  const { showOrgTree } = props.filters;
  const {
    reviewStatusCounts,
    selectedCustomer,
    customerName,
    hideDetails,
    setState,
    onInputChange,
    onStatusChange,
    getRecords,
    siteId 
  } = useCustomerView();

  const {
    showExtraFilters,
    selectedCustomerState,
    customerStatusTypes,
    lastInteractionDateFrom,
    lastInteractionDateTo,
    onDatesChange,
    onCustomerStateChange,
    toggleExtraFilters,
  } = useCustomerFilters();

  useEffect(fetchIdentityOptions, []);

  const handleNewCustomer = (customer) => {
    if (customer?.id) {
      getRecords();
      return;
    }
    const customerData = appendPlaceholders({
      ...customer,
      site: { id: siteId },
    });
    LoadingAction.set(true).then(() => {
      CustomerClient.Create(customerData).then(
        () => {
          LoadingAction.set(false);
          AlertModalAction.open("Successfully created customer!", "Success");
        },
        (error) => handleError(error),
      );
    });
  };

  const handleExists = (response) => handleNewCustomer(response.data[0]);

  const openNewCustomerModal = () => {
    LoginAction.dispatch({ isInReadMode: false });
    IdentityFormModalAction.onExists = handleExists;
    IdentityFormModalAction.open(fetchIdentityOptions, handleNewCustomer, {
      title: "Add New Customer",
      hideName: false,
      optionalName: false,
      showContacts: false,
      isEditing: false,
    });
  };

  return (
    <Grid>
      <Grid.Row className="flex-row-center">
        <Grid.Column width={2} className="flex-row-center">
          <OrgTreeButton
            active={showOrgTree}
            onClick={() =>
              props.fetchCustomerFilters({
                showOrgTree: !showOrgTree,
              })
            }
          />
          <Button
            icon="filter"
            color="blue"
            basic={!showExtraFilters}
            onClick={toggleExtraFilters}
          />
        </Grid.Column>
        <Grid.Column width={5}>
            <label>
              <b>Interaction Date:</b>
            </label>
            <div className="w-100 flex-row-center gap-1" >
              <DatePeriodFilters
                fromDate="lastInteractionDateFrom"
                toDate="lastInteractionDateTo"
                onChange={onDatesChange}
                data={{ lastInteractionDateFrom, lastInteractionDateTo }}
                showTimeFilters={false}
                inputWidth="140px"
              />
            </div>
        </Grid.Column>
        <Grid.Column width={3}>
          <SimpleInputComponent
            name="customerName"
            label="Customer search:"
            className=""
            labelClassName=""
            value={customerName}
            onChange={onInputChange}
          />
        </Grid.Column>
        <Grid.Column width={5} className="flex-right flex-row-center" style={{ marginBottom: "-1.5em" }}>
          <Button
            positive
            icon="refresh"
            content="Refresh"
            onClick={getRecords}
            size="small"
          />
          <Button
            color='violet'
            icon="plus"
            content="New Customer"
            onClick={openNewCustomerModal}
            size="small"
            disabled={!siteId}
          />
          {selectedCustomer && (
            <ExpandButton
              content={hideDetails ? "Show Details" : "Hide Details"}
              compact={false}
              onClick={() => setState({ hideDetails: !hideDetails })}
            />
          )}
        </Grid.Column>
      </Grid.Row>
      {showExtraFilters && (
        <Grid.Row>
          <Grid.Column className="flex-row-center">
            <div>
              <StatusLabels
                labels={reviewStatusCounts}
                onClick={onStatusChange}
              />
            </div>
            <SimpleSelectComponent
              className=""
              selectClassName=""
              label="Customer state: &nbsp;"
              labelClassName=""
              options={customerStatusTypes}
              value={selectedCustomerState}
              onChange={onCustomerStateChange}
            />
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    filters: state.customerFilters,
  };
};

export default connect(mapStateToProps, { fetchCustomerFilters })(
  CustomerFilters,
);
